import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import AssetProperties from "./AssetProperties";
import { makeGetConfigValue } from "../../selectors/config";
import { generateShortcutText } from "../../util/keyShortcutUtils";
import { actions as appActions } from "../../actions/app";
import localize from "../../util/localizeUtils";

const Container = styled.table`
  margin-bottom: 0;
`;

const HeaderBar = styled.tr`
  width: 100%;
  background-color: ${props => props.theme.table.header};
  height: 1.1rem;
`;

const HeaderText = styled.th`
  min-width: ${props => props.minWidth};
  font-size: 10px;
  padding: 0 0.5rem;
  width: ${props => props.width};
`;

const Head = styled.thead`
  border: 0;
`;

const Body = styled.tbody`
  border: 0;
`;

class EditorFooterContent extends Component {
  componentDidMount() {
    this.props.changeFooterHeight("5rem");
  }

  render() {
    const {
      showTimecode,
      showSlug,
      showChannel,
      isModifierActive
    } = this.props;
    return (
      <Container>
        <Head>
          <HeaderBar>
            {showChannel ? (
              <HeaderText width="25%">
                {generateShortcutText(
                  localize("channelHeader"),
                  isModifierActive
                )}
              </HeaderText>
            ) : (
              ""
            )}
            {showTimecode ? (
              <HeaderText width="25%" minWidth="10.2rem">
                {generateShortcutText(
                  localize("timecodeHeader"),
                  isModifierActive
                )}
              </HeaderText>
            ) : (
              ""
            )}
            {showSlug ? (
              <HeaderText minWidth="10.2rem">
                {generateShortcutText(localize("slugHeader"), isModifierActive)}
              </HeaderText>
            ) : (
              ""
            )}
          </HeaderBar>
        </Head>
        <Body>
          <AssetProperties />
        </Body>
      </Container>
    );
  }
}

EditorFooterContent.propTypes = {
  showTimecode: PropTypes.bool.isRequired,
  showSlug: PropTypes.bool.isRequired,
  showChannel: PropTypes.bool.isRequired,
  isModifierActive: PropTypes.bool.isRequired,
  changeFooterHeight: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const getConfigValue = makeGetConfigValue();

  return {
    showTimecode:
      getConfigValue(state, "userConfig", "timecodeDisplay", "show") === "show",
    showSlug:
      getConfigValue(state, "userConfig", "slugDisplay", "show") === "show",
    showChannel:
      getConfigValue(state, "userConfig", "channelDisplay", "show") === "show",
    isModifierActive: state.keyShortcuts.isModifierActive
  };
};

const mapActionCreators = {
  changeFooterHeight: appActions.changeFooterHeight
};

export default connect(mapStateToProps, mapActionCreators)(EditorFooterContent);



// WEBPACK FOOTER //
// ./app/components/Editor/EditorFooterContent.js